import {
    LISTS_CAMPUSES,
    LISTS_UTILITIES,
    LISTS_TRANSITS,
    LISTS_RESET
} from './mutation-types'
import { structure } from './state'

export const _build = (node, payload) => {
    if(node.hash !== payload.hash) {
        node.data = {}
        node.total = 0
    }
    
    node.loaded = payload.loaded
    node.npk = payload.npk
    node.lastSync = payload.lastSync
    node.filters = payload.filters
    node.hash = payload.hash
    
    for(let i=0; i<payload.data.length; i++) {
        let j = 'I'+payload.data[i].id
        node.data[j] = payload.data[i]
        node.total++
    }
}

export default {
    [LISTS_CAMPUSES](state, payload) {
        _build(state.campuses, payload)
    },
    
    [LISTS_UTILITIES](state, payload) {
        _build(state.utilities, payload)
    },
    
    [LISTS_TRANSITS](state, payload) {
        _build(state.transits, payload)
    },
    
    [LISTS_RESET](state, objName) {
        state[objName] = structure()
    }
}
